import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/lib/auth";
import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import About from "@/pages/About";
import Activities from "@/pages/Activities";
import Schemes from "@/pages/Schemes";
import SchemeDetail from "@/pages/SchemeDetail";
import Assessors from "@/pages/Assessors";
import Tuk from "@/pages/Tuk";
import News from "@/pages/News";
import NewsDetail from "@/pages/NewsDetail";
import Register from "@/pages/Register";
import RegisterSuccess from "@/pages/RegisterSuccess";
import CheckCertificate from "@/pages/CheckCertificate";
import AdminLogin from "@/pages/admin/AdminLogin";
import AdminLayout from "@/pages/admin/AdminLayout";
import AdminDashboard from "@/pages/admin/AdminDashboard";
import AdminApplicants from "@/pages/admin/AdminApplicants";
import AdminSchemes from "@/pages/admin/AdminSchemes";
import AdminAssessors from "@/pages/admin/AdminAssessors";
import AdminTuk from "@/pages/admin/AdminTuk";
import AdminActivities from "@/pages/admin/AdminActivities";
import AdminNews from "@/pages/admin/AdminNews";
import AdminSettings from "@/pages/admin/AdminSettings";
import AdminCertificates from "@/pages/admin/AdminCertificates";

function AdminGate({ children }) {
  const { user } = useAuth();
  if (user === null) return <div className="p-8 text-center text-slate-500">Memuat...</div>;
  if (!user || user.role !== "admin") return <Navigate to="/admin/login" replace />;
  return children;
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Toaster position="top-right" richColors />
        <Routes>
          <Route element={<Layout />}>
            <Route path="/" element={<Home />} />
            <Route path="/tentang" element={<About />} />
            <Route path="/kegiatan" element={<Activities />} />
            <Route path="/skema" element={<Schemes />} />
            <Route path="/skema/:id" element={<SchemeDetail />} />
            <Route path="/asesor" element={<Assessors />} />
            <Route path="/tuk" element={<Tuk />} />
            <Route path="/berita" element={<News />} />
            <Route path="/berita/:id" element={<NewsDetail />} />
            <Route path="/daftar" element={<Register />} />
            <Route path="/daftar/sukses/:regNo" element={<RegisterSuccess />} />
            <Route path="/cek-sertifikat" element={<CheckCertificate />} />
          </Route>
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin" element={<AdminGate><AdminLayout /></AdminGate>}>
            <Route index element={<AdminDashboard />} />
            <Route path="pendaftar" element={<AdminApplicants />} />
            <Route path="skema" element={<AdminSchemes />} />
            <Route path="asesor" element={<AdminAssessors />} />
            <Route path="tuk" element={<AdminTuk />} />
            <Route path="kegiatan" element={<AdminActivities />} />
            <Route path="berita" element={<AdminNews />} />
            <Route path="sertifikat" element={<AdminCertificates />} />
            <Route path="pengaturan" element={<AdminSettings />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
